var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStudyFlashcard = function SvgStudyFlashcard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 93 120"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 75.79,
    height: 101.053,
    x: 9.174,
    y: 12.14,
    fill: "#252B37",
    rx: 12.632
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 75.79,
    height: 101.053,
    x: 3.702,
    y: 6.667,
    fill: "currentColor",
    rx: 12.632
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#study-flashcard_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EFF8FF",
    d: "M18.596 69.298h-4.155l12.017-32.727h4.091l12.017 32.727h-4.155l-9.78-27.55h-.255zm1.534-12.784h16.747v3.516H20.13zm34.246 13.36q-2.334 0-4.235-.88-1.902-.895-3.02-2.572-1.119-1.694-1.119-4.091 0-2.11.831-3.42a5.87 5.87 0 0 1 2.221-2.077q1.39-.751 3.068-1.119a37 37 0 0 1 3.404-.607q2.237-.288 3.628-.432 1.406-.16 2.045-.527.655-.367.655-1.279v-.127q0-2.365-1.294-3.676-1.278-1.31-3.883-1.31-2.7 0-4.235 1.182-1.535 1.183-2.157 2.525l-3.58-1.278q.96-2.238 2.557-3.484a9.6 9.6 0 0 1 3.516-1.758 14.6 14.6 0 0 1 3.77-.511q1.184 0 2.718.288 1.55.27 2.988 1.134 1.455.864 2.413 2.605.959 1.742.959 4.666v16.172h-3.772v-3.324h-.191q-.384.8-1.279 1.71t-2.38 1.55-3.628.64m.575-3.388q2.237 0 3.771-.88 1.55-.878 2.333-2.268a5.8 5.8 0 0 0 .8-2.925v-3.452q-.24.288-1.055.528a18 18 0 0 1-1.854.4q-1.038.16-2.03.287-.975.112-1.581.192-1.47.19-2.75.623-1.261.416-2.045 1.262-.766.83-.767 2.27 0 1.964 1.455 2.972 1.47.99 3.723.99"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "study-flashcard_svg__a",
    width: 53.184,
    height: 35.303,
    x: 14.441,
    y: 36.571,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1586_49650"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1586_49650",
    result: "shape"
  })))));
};
export default SvgStudyFlashcard;